import { render } from "./pickTable.vue?vue&type=template&id=360ffb02&ts=true"
import script from "./pickTable.vue?vue&type=script&lang=ts"
export * from "./pickTable.vue?vue&type=script&lang=ts"

import "./pickTable.vue?vue&type=style&index=0&id=360ffb02&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__